import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text, useResponsive } from '@common-fe/common-fe';

interface Props {
  toggleOptions: string[];
  selectedOption: string;
  setSelectedOption: (value: string) => void;
}

export const EnrollmentDetailsToggler: React.FC<Props> = ({
  toggleOptions,
  selectedOption,
  setSelectedOption,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const isSelectedOption = (option: string) => option === selectedOption;
  return (
    <Box
      data-testid="MakeContributionModalToggler_container"
      direction="row"
      gap="spacing8"
      margin={{ bottom: 'spacing24' }}
      pad={isMobile ? undefined : 'spacing4'}
      background={{ color: isMobile ? 'transparent' : 'module' }}
      round={isMobile ? undefined : 'container1Round'}
      width={isMobile ? '100%' : { max: 'fit-content' }}
    >
      {toggleOptions.map((option) => (
        <Box
          data-testid="MakeContributionModalToggler_item"
          key={option}
          pad={{ horizontal: isMobile ? 'spacing8' : 'spacing24', vertical: 'spacing12' }}
          align="center"
          justify="center"
          height={isMobile ? '48px' : '40px'}
          background={{ color: isSelectedOption(option) ? 'canvas' : 'transparent' }}
          border={{ color: isSelectedOption(option) ? 'border2' : 'transparent', size: 'small' }}
          round="container2Round"
          onClick={() => setSelectedOption(option)}
          style={{ cursor: 'pointer', flex: isMobile ? 1 : 'initial' }}
        >
          <Text
            weight={isSelectedOption(option) ? 700 : 400}
            color={isSelectedOption(option) ? 'textBody' : 'textAccent'}
            size="medium"
            style={{ textAlign: 'center' }}
          >
            {t(option)}
          </Text>
        </Box>
      ))}
    </Box>
  );
};
